export default __webpack_public_path__ + "static/media/time.0a80f06e.svg";